import React, { forwardRef } from 'react'
import ObrysIkony from './ObrysIkony'

/**
 * Falownik: symbol przekształtnika ze schematów elektrycznych, czyli kwadrat przecięty przekątną,
 * z prądem stałym („=”) w jednym rogu i przemiennym („~”) w drugim. Zamiast pioruna (BoltIcon),
 * który właściciel uznał 2026-10-09 za zbyt ogólny: piorun to „prąd”, a nie urządzenie.
 */
const IkonaFalownika = forwardRef((props, ref) => (
  <ObrysIkony ref={ref} {...props}>
    <rect x='3.75' y='3.75' width='16.5' height='16.5' rx='2.25' />
    <path d='M5.25 18.75 18.75 5.25' />
    {/* Prąd stały: linia ciągła nad przerywaną. */}
    <path d='M6.75 7.5h4.5M6.75 9.75h.75M8.625 9.75h.75M10.5 9.75h.75' />
    {/* Prąd przemienny: fala. */}
    <path d='M12.75 15.75c.75-1.125 1.5-1.125 2.25 0s1.5 1.125 2.25 0' />
  </ObrysIkony>
))

export default IkonaFalownika
